
export const WINNERS_LIST_ATTEMPT = "WINNERS_LIST_ATTEMPT";
export const WINNERS_LIST_SUCCESS = "WINNERS_LIST_SUCCESS";
export const WINNERS_LIST_FAILED = "WINNERS_LIST_FAILED";
////////////
export const LOSERS_LIST_ATTEMPT = "LOSERS_LIST_ATTEMPT";
export const LOSERS_LIST_SUCCESS = "LOSERS_LIST_SUCCESS";
export const LOSERS_LIST_FAILED = "LOSERS_LIST_FAILED";
